import React, { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import styled from 'styled-components';

import { ItemCard } from '../components/ItemCard';
import { Loading } from '../components/Loading';
import { Notification } from '../components/Notification';

const db = firebase.firestore();

export function ListDetail({ history, match }) {
  const [list, setList] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [errors, setErrors] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await db
          .collection('lists')
          .doc(match.params.id)
          .get();

        const finalList = {
          id: list.id,
          ...list.data()
        };

        if (finalList) {
          setListLoading(false);
          setList(finalList);
        }
      } catch ({ message }) {
        console.log(message);
      }
    };

    fetchData();
  }, []);

  const markItem = async (e, index, listId = match.params.id) => {
    e.preventDefault();
    const newList = { ...list };
    const items = newList.items;
    const item = items[index];
    item.done = !item.done;
    await db
      .collection('lists')
      .doc(listId)
      .update({
        items
      });

    const listCollection = await db
      .collection('lists')
      .doc(listId)
      .get();
    const finalList = {
      id: listCollection.id,
      ...listCollection.data()
    };

    setList(finalList);

    // check if all list items are done with updated list
    // if it is, ask to archive or auto archive
    // auto archiving for now
    const listUpdate = await db
      .collection('lists')
      .doc(listId)
      .get();
    const updatedList = listUpdate.data();
    const listDone = updatedList.items.every(items => items.done === true);
    listDone
      ? await db
          .collection('lists')
          .doc(listId)
          .update({
            listDone: true
          })
      : await db
          .collection('lists')
          .doc(listId)
          .update({
            listDone: false
          });
  };

  const markShopper = async (buttonIndex, listId = match.params.id) => {
    const newList = { ...list };
    let shopper = newList.shopper;
    const newArray = shopper.map(me => (me = false));
    newArray[buttonIndex] = true;

    await db
      .collection('lists')
      .doc(listId)
      .update({
        shopper: [...newArray]
      });

    const listCollection = await db
      .collection('lists')
      .doc(listId)
      .get();
    const finalList = {
      id: listCollection.id,
      ...listCollection.data()
    };

    setList(finalList);
  };

  const archiveList = async () => {
    try {
      await db
        .collection('lists')
        .doc(match.params.id)
        .delete();
      history.push('/list');
    } catch ({ message }) {
      setErrors(message);

      setTimeout(() => {
        setErrors('');
      }, 5000);
    }
  };

  return (
    <>
      {errors && <Notification>{errors}</Notification>}
      <Flex>
        <Header>Selected list</Header>
        <button onClick={archiveList}>Delete list</button>
      </Flex>
      {listLoading && <Loading />}
      {listLoading !== true && list && (
        <ItemCard
          key={list.id}
          list={list}
          items={list.items}
          shopper={list.shopper}
          markItem={markItem}
          markShopper={markShopper}
        />
      )}
    </>
  );
}

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 30px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    background: transparent;
    border: none;
    font-size: 1rem;
    font-weight: bold;
  }
`;
